import { render, staticRenderFns } from "./CommonlyUsed.vue?vue&type=template&id=c870af32&scoped=true&"
import script from "./CommonlyUsed.vue?vue&type=script&lang=js&"
export * from "./CommonlyUsed.vue?vue&type=script&lang=js&"
import style0 from "./CommonlyUsed.vue?vue&type=style&index=0&id=c870af32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c870af32",
  null
  
)

export default component.exports